import React from "react";
import { chakra, Text, VStack, HStack, Icon, Box } from "@chakra-ui/react";
import { Reorder, useDragControls, motion } from "framer-motion";
import { FiMove } from "react-icons/fi";
import { useCallback, useRef } from "react";
import useMeasure from "react-use-measure";

const Item = chakra(Reorder.Item);
const MotionBox = motion(Box);

const DraggableItem = ({
  children,
  id,
  isDisabled,
  handleDragEnd,
}: {
  children: React.ReactNode;
  id: string;
  isDisabled?: boolean;
  handleDragEnd?: () => void;
}) => {
  const dragControls = useDragControls(); // unique per item
  const [ref, bounds] = useMeasure({
    debounce: 100,
  });

  // Handler to start drag for this item
  const handlePointerDown = (e: React.PointerEvent) => {
    dragControls.start(e);
  };

  // Clone the child and inject onPointerDown
  const childWithHandler = React.cloneElement(children as React.ReactElement, {
    onPointerDown: handlePointerDown,
  });

  return (
    <Item
      userSelect={"none"}
      key={id}
      id={id}
      value={id}
      style={{
        backgroundColor: "white",
        position: "relative",
      }}
      borderBottomWidth={1}
      borderBottomColor={"gray.100"}
      dragControls={dragControls}
      dragListener={false}
      onDragEnd={handleDragEnd}
      cursor="grab"
      _active={{ cursor: "grabbing" }}
      initial={false}
      animate={{ height: bounds.height }}
    >
      <VStack ref={ref} w="full" display="flex" flexDirection="column">
        {childWithHandler}
      </VStack>
    </Item>
  );
};

export default DraggableItem;
